module.exports = __webpack_public_path__ + "media/backstab.411bf5bf.wav";